import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';

const FeedbackModal: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      onClick={handleBackdropClick}
    >
      <div className="bg-white dark:bg-gray-800 rounded-lg w-full max-w-4xl h-[80vh] relative">
        <iframe
          src="https://icn4f81kkfru.feishu.cn/share/base/form/shrcnoIkC6EK5p8s3S5GPG3gbDc"
          className="w-full h-full rounded-lg"
          frameBorder="0"
          allow="clipboard-write"
          sandbox="allow-scripts allow-same-origin allow-forms"
        />
      </div>
    </div>
  );
};

const Footer: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="bg-gray-100 dark:bg-gray-900 py-6 mt-auto">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center text-gray-600 dark:text-gray-400 text-sm">
            <div className="mb-4 md:mb-0">
              <span>© {currentYear} Sohobot. All rights reserved.</span>
            </div>
            <div className="flex space-x-6 items-center">
              <Link to="/user-manual" className="hover:text-blue-600 transition-colors">
                用户手册
              </Link>
              <Link to="/privacy" className="hover:text-blue-600 transition-colors">
                隐私声明
              </Link>
              <button 
                onClick={() => setIsModalOpen(true)}
                className="flex items-center gap-2 text-blue-600 hover:text-blue-700 transition-colors"
              >
                <MessageSquare className="w-4 h-4" />
                用户反馈
              </button>
            </div>
          </div>
        </div>
      </footer>
      
      <FeedbackModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
};

export default Footer; 